import { useQueryClient } from '@tanstack/react-query'
import { useRef } from 'react'

/** Peel the `{ data: … }` envelope a JsonResource adds. */
export function unwrap<T>(wrapper: { data?: unknown }, endpoint: string): T {
  if (wrapper.data === undefined || wrapper.data === null) {
    throw new Error(`Malformed ${endpoint} response: missing data envelope.`)
  }
  return wrapper.data as T
}

/** Read the latest company ID when a mutation is called, not when its hook is created. */
export function useFreshCompanyId(companyId: string | null): () => string {
  const ref = useRef(companyId)
  ref.current = companyId
  return () => ref.current ?? ''
}

export function companyHeader(companyId: string): { 'X-Company-Id': string } {
  return { 'X-Company-Id': companyId }
}

/** Invalidate every accounting query after an accounting mutation. */
export function useInvalidateAccounting(companyId: string) {
  const queryClient = useQueryClient()

  return () => {
    void queryClient.invalidateQueries({ queryKey: ['companies', companyId, 'accounting'] })
  }
}
